const baseUrl = process.env.REACT_APP_BASE_PATH;

export const URL_LOGIN = baseUrl + 'auth/login';
export const URL_PROFILE_PIC_UPLOAD = baseUrl + 'candidate/profile-picture';
export const URL_CANDIDATE_REGISTER = baseUrl + 'candidate/register';
export const URL_CANDIDATE_DETAILS = baseUrl + 'me';
export const URL_JOB_OPENINGS = baseUrl + 'job-openings';
export const URL_ASSIGNMENTS = baseUrl + 'assignments';
